import { render, staticRenderFns } from "./Election.vue?vue&type=template&id=43a07a2d&"
import script from "./Election.vue?vue&type=script&lang=js&"
export * from "./Election.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports